import React from 'react';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useAuthenticationState } from '@/hooks/use-authentication';
import { z } from 'zod';
import { WelcomeSection } from '@/routes/_layout/sign-in/-components/welcome-section';
import { SignInCard } from '@/routes/_layout/sign-in/-components/sign-in-card';
export const Route = createFileRoute('/_layout/sign-in/')({
    component: SignInPage,
    validateSearch: z.object({
        redirect: z.string().optional().default('/console'),
        error: z.enum(['oauth']).optional(),
    }),
    beforeLoad: ({ context, search }) => {
        if (context.authentication?.status === 'authenticated') {
            throw redirect({ to: search.redirect || '/console' });
        }
    },
});
function SignInPage() {
    const { redirect, error } = Route.useSearch();
    const navigate = useNavigate();
    const { t } = useTranslation(['glossary']);
    const { user } = useAuthenticationState();
    React.useEffect(() => {
        if (user) {
            const path = redirect || '/console';
            navigate(path).then();
        }
    }, [navigate, redirect, user]);
    React.useEffect(() => {
        if (error === 'oauth') {
            toast.error(t('sign_in.oauth_interrupted', { ns: 'glossary' }));
            // Drop the flag so a refresh doesn't re-show the toast.
            navigate({ to: '/sign-in', search: { redirect }, replace: true }).then();
        }
    }, [error, navigate, redirect, t]);
    return (<div className="relative min-h-dvh bg-linear-to-b from-background via-background to-muted/30">
            {/* Main */}
            <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center">
                    {/* Brand / copy */}
                    <WelcomeSection />
                    {/* Auth card */}
                    <div className="order-1 md:order-2">
                        <SignInCard />
                    </div>
                </div>
            </main>
        </div>);
}
